import React from "react";

// mui
import { FormGroup } from "@material-ui/core";

// components
import FormikSwitch from "@components/molecules/FormikSwitch";
import HelpToolTip from "@components/atoms/HelpToolTip";
import FormikRadioButtons from "@components/molecules/FormikRadioButtons";
import HelpTipMessages from "@components/molecules/HelpTipMessages";
import FormikTextField from "@components/molecules/FormikTextField";

type Props = {
  masterSubordinateFlg: boolean;
  multiFunctionOfficeFlag: boolean;
  nameOfMasterFlg: "basic.masterFlg" | "basic.isMasterRadioValue";
  nameOfMultiFunctionOfficeFlag:
    | "basic.multiFunctionOfficeFlag"
    | "basic.multiFunctionOfficeFlg";
};
export const MultiFunctionMasterSubordinateFormGroup = (
  props: Props
): JSX.Element => {
  const {
    masterSubordinateFlg,
    multiFunctionOfficeFlag,
    nameOfMasterFlg,
    nameOfMultiFunctionOfficeFlag
  } = props;
  return (
    <>
      <FormGroup>
        <FormikSwitch
          name="basic.masterSubordinateFlg"
          label="主従たる事業所"
          disabled
          highEmphasisDisabledStyle
          tooltip={
            <HelpToolTip
              title={<HelpTipMessages name="masterSubordinateTipsMessage" />}
            />
          }
        />
        {masterSubordinateFlg && (
          <FormikRadioButtons
            name={nameOfMasterFlg}
            label=""
            disabled
            highEmphasisDisabledStyle
            options={[
              { label: "主たる事業所", value: "1" },
              {
                label: "従たる事業所",
                value: "0"
              }
            ]}
            style={{ marginTop: -20, marginLeft: 32, display: "inline" }}
          />
        )}
      </FormGroup>
      <FormGroup>
        <FormikSwitch
          name={nameOfMultiFunctionOfficeFlag}
          label="多機能型事業所"
          disabled
          highEmphasisDisabledStyle
          tooltip={
            <HelpToolTip
              title={<HelpTipMessages name="multipleFacilityTipsMessage" />}
            />
          }
        />
        {multiFunctionOfficeFlag && (
          <FormikTextField
            name="basic.allCapacity"
            label="総利用定員数"
            placeholder="0"
            endAdornmentLabel="人"
            style={{ marginTop: -20, marginLeft: 32 }}
          />
        )}
      </FormGroup>
    </>
  );
};
